import React, { useEffect, useMemo, useState } from 'react'
import { observer } from 'mobx-react'
import { Icon } from 'components'
import { deliveryMobx, checkoutMobx, memberMobx } from '@mobxStore'
import { cartMobx, restaurantCenter, RESTAURANT_EVENT } from '@mobx/mall'
import { SelectAddressModal } from '@cps'
import { modalLayer } from '@utils'
import { LoginGuide } from '../../component'
import repositoryMobx from '@mobx/mall/repository.mobx'
import deliveryController from '@ctrls/deliveryController'
import expressLineImg from 'assets/images/mall/express_line.jpg'
import './index.scss'

const CheckoutAddress: React.FC = () => {
  const { address, viewAddressesAll, hasAddresses } = deliveryMobx
  const { contactError } = checkoutMobx
  const handleClick = () => {
    if (hasAddresses) {
      modalLayer(SelectAddressModal, { type: 'mall' }, 'SelectAddressModal').then(() => {
      }, () => { })
    } else {
      deliveryController.editAddressModal({
        type: 'mall',
        callback (store) {}
      })
    }
  }

  useEffect(() => {
    setExpressFeeForBast()
  }, [cartMobx.info.contactInfo])

  useEffect(() => {
    const event = restaurantCenter.on(RESTAURANT_EVENT.CART_ITEMS_CHANGED, ({ type }) => {
      setExpressFeeForBast()
    })
    return () => {
      restaurantCenter.off(event)
    }
  }, [])

  const setExpressFeeForBast = async () => {
    let fee = repositoryMobx.calcExpressFeeForProd(cartMobx.cartItems.map(({ productNo: no }) => no), cartMobx.info?.contactInfo?.extra)
    cartMobx.setExpressPrice(fee)
  }

  return (
    <div className='mall-checkout-address-container'>
      <LoginGuide isLogin={memberMobx.isLogin} />
      <div className='mall-checkout-address-wrapper' onClick={handleClick}>
        {/* <Icon name={bo === 'cn' ? 'delivery-cn' : 'delivery-us'} /> */}
        {
          address && cartMobx.info?.contactInfo?.shortAddress ? (
            <div className='checkout-address-info'>
              <div className='contact-way middle'>{cartMobx.info?.contactInfo?.middleAddress}</div>
              <div className='contact-address'>{cartMobx.info?.contactInfo?.shortAddress}</div>
              <div className='contact-way'>{cartMobx.info.contactName} {cartMobx.info.contactMobile}</div>
            </div>
          ) : <div className={`checkout-address-info${contactError.addressError && !cartMobx.info?.contactInfo?.shortAddress ? ' error' : ''}`}>{i18n.t(!viewAddressesAll?.length ? 'newCart.addAddressTip' : 'newCart.selectAddress')}</div>
        }
        <Icon name='chevron-right' />
      </div>
      <div className='express-line-img' style={{ backgroundImage: `url(${expressLineImg})` }}></div>
    </div>
  )
}

export default observer(CheckoutAddress)
